import {ELanguage} from 'src/constants';
import {ECountries} from 'src/containers/LeadCompanyClients';

export enum EFormStep {
  COUNTRY = 'COUNTRY',
  NAME = 'NAME',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}

export const CISCountries: string[] = [
  ECountries.KAZ,
  ECountries.AZE,
  ECountries.ARM,
  ECountries.KGZ,
  ECountries.MDA,
  ECountries.TJK,
  ECountries.UZB,
  ECountries.TKM,
  ECountries.GEO,
];

export const OSKCountries: string[] = [
  ECountries.RUS,
  ECountries.BLR,
  ECountries.ABH,
  ECountries.OST,
];

export const HONEY_POT_INPUT_ID = 'address';
export enum EErrors {
  EMAIL_EXISTS = 'tenant-lead.email-already-exists',
  INVALID_CAPTCHA = 'captcha.verification-failed',
}

export type TFormData = {
  countryCode: string;
  locale: ELanguage;
  contactName: string;
  phone: {value: string; countryCode: string};
  email: string;
  agentId?: number;
  isAgreementAccepted?: boolean;
  isAdvertisementAccepted?: boolean;
  captchaId: string;
  captcha: string;
  [HONEY_POT_INPUT_ID]: string;
};

export type TSignUpPayload = Omit<TFormData, 'phone'> & {phone: string};
